<yo-generic-datagrid-pn [pathFileHelp]="pathFile" [service]="allergenesSvc"></yo-generic-datagrid-pn>
